const initialState = {
  rentalPlanning: {},
  loading: false
};

export function fetchRentalPlanning(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_RENTAL_PLANNING.SUCCESS':
      return {
        ...state,
        rentalPlanning: action.rentalPlanning.body,
      };
    default:
      return state
  }
}

export function saveRentalPlanning(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_RENTAL_PLANNING.SUCCESS':
      return {
        ...state,
        rentalPlanning: action.rentalPlanning.body,
      };
    default:
      return state
  }
}
